export const getDictionaryItem = {
	methods: {
		getDictionaryItem(list, field, id, itemId) {
			var item = list.length;
			while (item--) {
				if (list[item][id] === itemId) {
					return list[item][field];
				}
			}
		},
	},
};
